<script setup lang="ts">
import { useDisplay } from 'vuetify';
import ElevatedBtn from '../ui-elements/buttons/ElevatedBtn.vue';
import OutlinedBtn from '../ui-elements/buttons/OutlinedBtn.vue';
import LoadingCard from '../ui-elements/loaders/LoadingCard.vue';

const {
  activator,
  displayDoNotShowAgainInput = true,
  showActions = true,
  showLoadingAnimation = false,
} = defineProps<{
  activator: boolean
  displayDoNotShowAgainInput?: boolean
  title: string
  message: string
  showActions?: boolean
  showLoadingAnimation?: boolean
}>()
const emit = defineEmits(['close', 'after-leave', 'do-not-show-again', 'show-again', 'continue'])

const { mobile } = useDisplay()
</script>

<template>
  <v-dialog
    :model-value="activator"
    :width="mobile ? undefined : '70%'"
    :max-width="mobile ? undefined : '700px'"
    :content-class="mobile ? '' : 'rounded-lg'"
    @after-leave="emit('after-leave')"
    @update:modelValue="
      (val) => {
        if (!val) emit('close')
      }
    "
  >
    <v-card :rounded="mobile ? '0' : 'lg'" class="pa-4">
      <v-row no-gutters justify="end">
        <v-btn rounded="lg" size="small" color="pwt_off_white" flat>
          <v-icon color="pwt_light_grey" @click="emit('close')">mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-container class="px-5 py-2 d-flex flex-column align-center">
        <v-card flat max-width="70%">
          <v-card-title class="text-center pt-0 pb-8 font-weight-bold">
            {{ title }}
          </v-card-title>
          <v-card-text class="text-center">
            {{ message }}
          </v-card-text>
          <v-card-text v-if="showLoadingAnimation" class="pa-10 d-flex align-center justify-center">
            <LoadingCard :size="60" />
          </v-card-text>
          <v-card-actions v-if="showActions" class="justify-center pt-5">
            <OutlinedBtn @click="emit('close')" class="mr-2"> Cancel </OutlinedBtn>
            <ElevatedBtn @click="emit('continue')" class="ml-2"> Continue </ElevatedBtn>
          </v-card-actions>
        </v-card>
      </v-container>
      <v-row v-if="displayDoNotShowAgainInput" no-gutters justify="start" class="mt-0 px-5 pb-5">
        <v-checkbox
          color="pwt_palatinate_blue"
          base-color="pwt_palatinate_blue"
          hide-details
          density="compact"
          @update:modelValue="
            (val) => {
              if (val) emit('do-not-show-again')
              else emit('show-again')
            }
          "
        >
          <template v-slot:label>
            <span class="text-pwt_palatinate_blue text-decoration-underline text-caption">
              Don't show again
            </span>
          </template>
        </v-checkbox>
      </v-row>
    </v-card>
  </v-dialog>
</template>
